import classNames from 'classnames';
import { Link, generatePath } from 'react-router-dom';
import { ROUTES } from '@/constants';
import type { CategoryCatalog } from '@/interfaces/strapi';

type CatalogCategoriesListProps = {
	readonly className?: string;
	readonly isLoading?: boolean;
	readonly categories?: CategoryCatalog[];
	readonly title?: string;
};

const classNameComponent = 'c-cnm-catalog-categories-list';

export function CatalogCategoriesList({
	className,
	isLoading = false,
	categories = [],
	title = 'Materias',
}: CatalogCategoriesListProps) {
	const wrapperClassName = classNames(classNameComponent, className);

	if (isLoading) {
		return (
			<section className={wrapperClassName} aria-busy="true">
				<p>Cargando categorías…</p>
			</section>
		);
	}

	if (!categories.length) {
		return (
			<section className={wrapperClassName}>
				<h3 className={`${classNameComponent}__title`}>{title}</h3>
				<p>No hay categorías disponibles.</p>
			</section>
		);
	}

	return (
		<section className={wrapperClassName}>
			<h3 className={`${classNameComponent}__title`}>{title}</h3>
			<ul className={`${classNameComponent}__list`}>
				{categories.map(({ id, slug, name }) => (
					<li key={id ?? slug} className={`${classNameComponent}__item`}>
						<Link to={generatePath(ROUTES.ACADEMIA_MATRITENSE_CATALOGO_BY_CATEGORY, { category: slug })}>
							{name}
						</Link>
					</li>
				))}
			</ul>
		</section>
	);
}
